module.exports = __webpack_public_path__ + "img/252-37eb7b.png";